<template>
  <IonPage>
      <master-layout page-title="دریافتی ها">
          <ion-card-content>
            <router-link to="/incoming/Add" class="btn btn-info">افزودن</router-link>
            <data-table card="true"  auto-reload="1" :headers="headers" :route="route" v-if="route"></data-table>
          </ion-card-content>

      </master-layout>
  </IonPage>
</template>

<script>
import DataTable from "@/components/DataTable";
import {IonPage,IonCardContent} from '@ionic/vue';

export default {
  name: "list",
  components: {DataTable,IonPage,IonCardContent},
  data(){
    return {
      headers: ['شماره فاکتور','مشتری','وضعیت','جمع','امکانات'],
      total_price: 0,
      customer_id: null,
      customer: null,
      route : 'incoming/ListAjax'
    }
  },


}
</script>

<style scoped>

</style>